import { render, staticRenderFns } from "./ToggleSelfAssignBtn.vue?vue&type=template&id=004fcf62&scoped=true&"
import script from "./ToggleSelfAssignBtn.vue?vue&type=script&lang=js&"
export * from "./ToggleSelfAssignBtn.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSelfAssignBtn.vue?vue&type=style&index=0&id=004fcf62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004fcf62",
  null
  
)

export default component.exports